(Site.Quiz = {
  elems: {
    form: document.getElementById("quiz-form"),
    carousel: document.getElementById("quiz-crsl"),
    quizPrevBtns: document.querySelectorAll(".quiz-nav-btn.prev"),
    quizNextBtns: document.querySelectorAll(".quiz-nav-btn.next"),
    genderBtns: document.querySelectorAll("#quiz-form .gender"),
    pregnancyWrap: document.getElementById("pregnancy-wrap"),
    pregnancyBtns: document.querySelectorAll("#quiz-form .pregnancy"),
    medicalNoTrigger: document.getElementById("medical-no-trigger"),
    medicalNo: document.getElementById("medical-no"),
    medicalYes: document.getElementById("medical-yes"),
    step4Checkboxes: document.getElementById("quiz-medical-conditions"),
    quizDots: document.getElementById("quiz-nav-btns"),
  },
  carousel: null,
  navigate(e, t) {
    //console.log(Site.Scroll)
    (t.disabled = !1),
      t.click(),
      Site.Quiz.elems.carousel.getBoundingClientRect().y < 0 &&
        Site.Scroll.scrollTo(Site.Quiz.elems.carousel);
  },
  handleSubmit(e) {
    if (!e.dataset.submitting) {
      e.dataset.submitting = 1;
      const t = {
        submit: e.querySelector(".submit"),
        sending: e.querySelector(".sending"),
        success: e.querySelector(".success"),
        error: e.querySelector(".error"),
      };
      t.submit.classList.add("invis"), t.sending.classList.remove("invis");
      const i = new FormData(e);
      fetch(e.getAttribute("action"), { method: "post", body: i })
        .then((e) => e.json())
        .then((i) => {
          200 === i.status || 201 === i.status
            ? (e.querySelector(".success-hide").classList.add("invis"),
              Site.Scroll.scrollTo(Site.Quiz.elems.carousel),
              Site.Quiz.elems.quizDots.querySelectorAll(".dot").forEach((e) => {
                e.disabled = !0;
              }),
              t.sending.classList.add("invis"),
              t.success.classList.remove("invis"))
            : Site.Form.handleError(e, t, i);
        })
        .catch((i) => {
          Site.Form.handleError(e, t, i);
        });
    }
  },
  init() {
    Site.Quiz.elems.form.addEventListener("submit", (e) => {
      e.preventDefault(),
        Site.Form.validate(Site.Quiz.elems.form, Site.Quiz.handleSubmit);
    }),
      Site.Carousel.create(
        Site.Quiz.elems.carousel,
        Site.Quiz.handleCarouselNav
      ),
      (Site.Quiz.carousel =
        Site.Carousel.carousels[
          Site.Quiz.elems.carousel.dataset.carouselIndex
        ]),
      Site.Quiz.elems.quizPrevBtns.forEach((e) => {
        e.addEventListener("click", () => {
          const t = Site.Quiz.elems.quizDots.querySelector(
            '.dot[data-id="' + e.dataset.id + '"]'
          );
          Site.Quiz.navigate("prev", t);
        });
      }),
      Site.Quiz.elems.quizNextBtns.forEach((e) => {
        e.addEventListener("click", () => {
          let t = !0;
          const i = e.closest(".crsl-cell");
          if (
            (i.querySelectorAll(".radio-group:not(.hidden)").forEach((e) => {
              e.querySelector("input:checked") || (t = !1);
            }),
            i.querySelector("#medical-yes") &&
              Site.Quiz.elems.medicalYes.checked &&
              (Site.Quiz.elems.step4Checkboxes.querySelector("input:checked") ||
                (t = !1)),
            t)
          ) {
            i.querySelector(".quiz-error").classList.add("invis");
            Site.Quiz.elems.quizDots
              .querySelector(
                '.dot[data-id="' + Site.Quiz.carousel.curCellID + '"]'
              )
              .classList.add("complete");
            const t = Site.Quiz.elems.quizDots.querySelector(
              '.dot[data-id="' + e.dataset.id + '"]'
            );
            Site.Quiz.navigate("next", t);
          } else i.querySelector(".quiz-error").classList.remove("invis");
        });
      }),
      Site.Quiz.elems.genderBtns.forEach((e) => {
        e.addEventListener("click", () => {
          "Male" === e.querySelector('input[type="radio"]').value
            ? (Site.Quiz.elems.pregnancyWrap.classList.add("hidden"),
              Site.Quiz.elems.pregnancyBtns.forEach((e) => {
                (e.querySelector('input[type="radio"]').checked = !1),
                  e.querySelector(".radio").classList.remove("active");
              }))
            : Site.Quiz.elems.pregnancyWrap.classList.remove("hidden");
        });
      }),
      Site.Quiz.elems.medicalNoTrigger.addEventListener("click", () => {
        Site.Quiz.elems.step4Checkboxes
          .querySelectorAll(".checkbox.active")
          .forEach((e) => {
            e.click();
          });
      });
  },
}),
  Site.Quiz.init();
